export type CalendarExportEvent={id:string;title:string;description:string;starts_at:string;ends_at?:string|null;all_day?:boolean;location_name?:string|null;visibility:string;status:string}
// Date-only reservations retain their Las Vegas dates in every viewer timezone.
export function guildDate(value:string){return new Intl.DateTimeFormat('en-CA',{timeZone:'America/Los_Angeles',year:'numeric',month:'2-digit',day:'2-digit'}).format(new Date(value))}
export function guildMidnight(day:string){
  const base=Date.parse(day+'T00:00:00Z');let midnight=base
  for(let i=0;i<3;i++){
    const offset=new Intl.DateTimeFormat('en-US',{timeZone:'America/Los_Angeles',timeZoneName:'shortOffset'}).formatToParts(new Date(midnight)).find(p=>p.type==='timeZoneName')!.value
    midnight=base-Number(offset.replace('GMT',''))*3600000
  }
  return new Date(midnight)
}
function guildDisplayDate(value:string){
  const [year,,day]=guildDate(value).split('-')
  const number=Number(day)
  const suffix=number%100>=11&&number%100<=13?'th':(['th','st','nd','rd'][number%10]||'th')
  const month=new Intl.DateTimeFormat('en-US',{timeZone:'America/Los_Angeles',month:'long'}).format(new Date(value))
  return `${month} ${number}${suffix}, ${year}`
}
export function eventSchedule(event:CalendarExportEvent){
  if(!event.all_day)return new Date(event.starts_at).toLocaleString(undefined,{dateStyle:'medium',timeStyle:'short'})+(event.ends_at?' – '+new Date(event.ends_at).toLocaleString(undefined,{dateStyle:'medium',timeStyle:'short'}):'')
  const end=event.ends_at?guildDate(new Date(new Date(event.ends_at).getTime()-1).toISOString()):guildDate(event.starts_at)
  return guildDisplayDate(event.starts_at)+(end!==guildDate(event.starts_at)?' – '+guildDisplayDate(new Date(new Date(event.ends_at!).getTime()-1).toISOString()):'')+' · Times to be determined'
}
export function localDateKey(date:Date){return `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')}`}
export function monthGrid(month:Date){
  const start=new Date(month.getFullYear(),month.getMonth(),1)
  start.setDate(start.getDate()-start.getDay())
  return Array.from({length:42},(_,i)=>new Date(start.getFullYear(),start.getMonth(),start.getDate()+i))
}
export function eventOnDay(event:CalendarExportEvent,day:Date){
  if(event.all_day){const key=localDateKey(day);return key>=guildDate(event.starts_at)&&key<=(event.ends_at?guildDate(new Date(new Date(event.ends_at).getTime()-1).toISOString()):guildDate(event.starts_at))}
  const start=new Date(day.getFullYear(),day.getMonth(),day.getDate()).getTime()
  const end=new Date(day.getFullYear(),day.getMonth(),day.getDate()+1).getTime()
  const eventStart=new Date(event.starts_at).getTime()
  const eventEnd=event.ends_at?new Date(event.ends_at).getTime():eventStart+1
  return eventStart<end&&eventEnd>start
}
export function toLocalInput(value:string|null|undefined){
  if(!value)return ''
  const d=new Date(value)
  return `${localDateKey(d)}T${String(d.getHours()).padStart(2,'0')}:${String(d.getMinutes()).padStart(2,'0')}`
}
function icsText(value:string){return String(value).replaceAll('\\','\\\\').replace(/\r\n|\r|\n/g,'\\n').replaceAll(';','\\;').replaceAll(',','\\,')}
function stamp(value:string){
  const d=new Date(value);if(!Number.isFinite(d.getTime()))throw new Error('Invalid event date')
  return d.toISOString().replace(/[-:]/g,'').replace(/\.\d{3}/,'')
}
// RFC 5545 folds at 75 octets, without splitting a UTF-8 character.
function fold(line:string){
  const encoder=new TextEncoder();let result='',chunk='',bytes=0
  for(const character of line){const size=encoder.encode(character).length;if(bytes+size>75){result+=chunk+'\r\n';chunk=' ';bytes=1}chunk+=character;bytes+=size}
  return result+chunk
}
export function calendarIcs(event:CalendarExportEvent,now=new Date()){
  if(!/^[a-zA-Z0-9-]+$/.test(event.id)||event.status!=='published')throw new Error('Only published events can be exported')
  const lines=['BEGIN:VCALENDAR','VERSION:2.0','PRODID:-//Kingdom of Ourrenland//Guild Calendar//EN','CALSCALE:GREGORIAN','METHOD:PUBLISH','BEGIN:VEVENT',
    `UID:${event.id}@ourrenland.com`,`DTSTAMP:${stamp(now.toISOString())}`,event.all_day?`DTSTART;VALUE=DATE:${guildDate(event.starts_at).replaceAll('-','')}`:`DTSTART:${stamp(event.starts_at)}`,
    ...(event.ends_at?[event.all_day?`DTEND;VALUE=DATE:${guildDate(event.ends_at).replaceAll('-','')}`:`DTEND:${stamp(event.ends_at)}`]:[]),`SUMMARY:${icsText(event.title)}`,`DESCRIPTION:${icsText(event.description)}`,
    `LOCATION:${icsText(event.location_name||'')}`,`CLASS:${event.visibility==='private'?'PRIVATE':'PUBLIC'}`,'END:VEVENT','END:VCALENDAR']
  return lines.map(fold).join('\r\n')+'\r\n'
}
